import type { LaunchHero, OrbGreeting } from '../types';

export const INTRO =
  'Your hiring copilot. Tell me what you need: I can filter and rank applicants, shortlist, message and schedule interviews for you.';

/** Asks what needs them across their jobs (get_hiring_overview). */
export const HERO: LaunchHero = {
  action: 'What needs my attention?',
  prompt: 'What needs my attention today?',
  caption:
    'New and undecided applicants across your jobs, and who to look at first.',
  continueAction: 'What needs my attention?',
};

/** The orb's hello once a day: the pipeline's most pressing thing (GET
 * /assistant/nudge, new applicants first), else an offer to help. */
export const GREETING: OrbGreeting = {
  fromServer: true,
  say: (name, firstEver) => ({
    key: 'hello',
    text: firstEver
      ? `Hi ${name}! I'm Abekus AI. Ask me to find, filter or shortlist candidates for any of your jobs.`
      : `${name}, want me to line up the applicants worth your time today?`,
  }),
};
